import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';

import {
  SET_LIST_FORM,
  SET_FORM,
  SET_ERROR_DELETE,
  SET_BILLER_OF_FORM,
  PROCESSING,
  CHECK_FORM_DELETION,
} from './types';

const { allBillerApiService } = apiService.getInstance();

export const resetCheckDeletion = dispatch => {
  dispatch({
    type: CHECK_FORM_DELETION,
    payload: { loading: false, allowedToDelete: false },
  });
};

export const getListForm = (paginationUrl, paramUrl = '') => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });

  const formsUrl = `forms?${paginationUrl}${paramUrl}`;

  allBillerApiService
    .get(formsUrl)
    .then(forms.onGetListFormSuccess(dispatch))
    .catch(forms.onGetListFormError(dispatch));
};

export const onGetListFormSuccess = dispatch => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch({
      type: SET_LIST_FORM,
      payload: payload.forms,
      pagination,
    });
  } else {
    dispatch({ type: SET_LIST_FORM, payload: [], pagination: {} });
    errorHandle(response);
  }
};

export const onGetListFormError = dispatch => error => {
  dispatch({ type: SET_LIST_FORM, payload: [], pagination: {} });
  errorHandle(error);
};

export const getForm = (id, callbackSuccess) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .get(`forms/${id}`)
    .then(forms.onGetFormSuccess(dispatch, callbackSuccess))
    .catch(forms.onGetFormError(dispatch));
};

export const onGetFormSuccess = (dispatch, callbackSuccess) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch({ type: SET_FORM, payload });
    callbackSuccess(payload);
  }
};

export const onGetFormError = dispatch => error => {
  errorHandle(error);
  dispatch({ type: SET_FORM, payload: {} });
};

export const checkFormToDelete = (
  id,
  callbackSuccess = () => {},
) => dispatch => {
  dispatch({
    type: CHECK_FORM_DELETION,
    payload: { loading: true, allowedToDelete: false },
  });
  allBillerApiService
    .get('services', { params: { form_id: id } })
    .then(forms.onCheckFormToDeleteSuccess(id, dispatch, callbackSuccess))
    .catch(forms.onCheckFormToDeleteError(dispatch));
};

export const onCheckFormToDeleteSuccess = (
  id,
  dispatch,
  callbackSuccess,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    const isLinkedService = payload.length;

    allBillerApiService
      .get('billers', { params: { form_id: id } })
      .then(resService => {
        if (resService.status === 200) {
          const servicePayload = resService.data.payload;

          if (!servicePayload.length && !isLinkedService) {
            dispatch({
              type: CHECK_FORM_DELETION,
              payload: { loading: false, allowedToDelete: true },
            });
            callbackSuccess();
          } else {
            forms.resetCheckDeletion(dispatch);
            callbackSuccess();
          }
        }
      })
      .catch(error => {
        errorHandle(error);
        forms.resetCheckDeletion(dispatch);
      });
  }
};

export const onCheckFormToDeleteError = dispatch => error => {
  errorHandle(error);
  forms.resetCheckDeletion(dispatch);
};

export const getBillerOfForm = (
  id,
  params,
  callbackSuccess,
  callbackError,
) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .get(`forms/${id}/billers`, {
      params: {
        page_num: 1,
        page_size: 6,
        ...params,
      },
    })
    .then(forms.onGetBillerOfFormSuccess(dispatch, callbackSuccess))
    .catch(forms.onGetBillerOfFormError(dispatch, callbackError));
};

export const onGetBillerOfFormSuccess = (
  dispatch,
  callbackSuccess,
) => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch({ type: SET_BILLER_OF_FORM, payload: [] });
    dispatch({ type: SET_BILLER_OF_FORM, payload });
    callbackSuccess(pagination);
  }
};

export const onGetBillerOfFormError = (dispatch, callbackError) => error => {
  dispatch({ type: SET_BILLER_OF_FORM, payload: [] });
  callbackError();
  errorHandle(error);
};

export const createNewForm = (params, callbackSuccess) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .post('forms', { ...params })
    .then(forms.onCreateNewFormSuccess(dispatch, callbackSuccess))
    .catch(forms.onCreateNewFormError(dispatch));
};

export const onCreateNewFormSuccess = (
  dispatch,
  callbackSuccess,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch({ type: SET_FORM, payload });
    callbackSuccess(payload);
  }
};

export const onCreateNewFormError = dispatch => error => {
  errorHandle(error);
  dispatch({ type: SET_FORM, payload: {} });
};

export const updateForm = (id, params, callbackSuccess) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .patch(`forms/${id}`, { ...params })
    .then(forms.onUpdateFormSuccess(id, dispatch, callbackSuccess))
    .catch(forms.onUpdateFormError(dispatch));
};

export const onUpdateFormSuccess = (
  id,
  dispatch,
  callbackSuccess,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch({ type: SET_FORM, payload });
    callbackSuccess(id);
  }
};

export const onUpdateFormError = dispatch => error => {
  errorHandle(error);
  dispatch({ type: SET_FORM, payload: {} });
};

export const deleteForm = (id, callbackSuccess) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .delete(`forms/${id}`)
    .then(forms.onDeleteFormSuccess(dispatch, callbackSuccess))
    .catch(forms.onDeleteFormError(dispatch));
};

export const onDeleteFormSuccess = (dispatch, callbackSuccess) => response => {
  if (response.status === 204) {
    dispatch({
      type: CHECK_FORM_DELETION,
      payload: { loading: false, allowedToDelete: false },
    });
    callbackSuccess();
  }
};

export const onDeleteFormError = dispatch => error => {
  dispatch({ type: SET_ERROR_DELETE });
  errorHandle(error);
};

const forms = {
  resetCheckDeletion,
  getListForm,
  onGetListFormSuccess,
  onGetListFormError,
  getForm,
  onGetFormSuccess,
  onGetFormError,
  checkFormToDelete,
  onCheckFormToDeleteSuccess,
  onCheckFormToDeleteError,
  getBillerOfForm,
  onGetBillerOfFormSuccess,
  onGetBillerOfFormError,
  createNewForm,
  onCreateNewFormSuccess,
  onCreateNewFormError,
  updateForm,
  onUpdateFormSuccess,
  onUpdateFormError,
  deleteForm,
  onDeleteFormSuccess,
  onDeleteFormError,
};

export default forms;
